import { parseHTML } from '../../../../services/parseHTML';

import React, { useContext, useEffect } from 'react';
import { OfferContext } from '../../context';

declare global {
    interface Window {
        Trustpilot: any;
    }
}

const applyTrustpilotScript = () => {
    document.querySelectorAll('.trustpilot-widget').forEach((element) => {
        window.Trustpilot.loadFromElement(element, true);
    });
};

export const Trustbox: React.FC = () => {
    const { trustboxCode } = useContext(OfferContext);
    /**
     * Shows a third-party trustbox iframe. The code of trustbox is set in the
     * Storyblok CMS - Content -> Offers -> Trustbox Code. This lets the user
     * to use this feature dynamically.
     * 
     * Below is an example of the code that is present in one of the offers.
     * @example
     *  <div
        class="trustpilot-widget"
        data-locale="nb-NO"
        data-template-id="5419b732fbfb950b10de65e5"
        data-businessunit-id="5cad92028abadb0001cf198f"
        data-style-height="24px"
        data-style-width="100%"
        data-theme="light">
            <a href="https://no.trustpilot.com/review/unofinans.no"
            target="_blank"
            rel="noopener">
                Trustpilot
            </a>
        </div>
     */
    useEffect(() => {
        if (!trustboxCode) return;

        /**
         * The code below ensures that trustbox code will be initialized if
         * any of the offers are using the trustbox. Also it will be
         * initialized only ONCE
         */
        if (!document.querySelector('#trustboxScript')) {
            const trustboxScript = document.createElement('script');
            trustboxScript.id = 'trustboxScript';
            trustboxScript.type = 'text/javascript';
            trustboxScript.src =
                '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
            trustboxScript.async = true;
            document.head.appendChild(trustboxScript);

            trustboxScript.onload = applyTrustpilotScript;
        }

        if (document.querySelector('#trustboxScript') && window.Trustpilot) {
            applyTrustpilotScript();
        }
    }, []);

    /**
     * We need to use parseHTML util when we are rendering
     * `offer.trustboxCode`because it is build using plain HTML so we need to
     * parse it to JSX
     */
    return trustboxCode ? <>{parseHTML(trustboxCode, 'markdown')}</> : null;
};
